/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TaxType } from './';
import {
    TaxTypeFromJSON,
    TaxTypeFromJSONTyped,
    TaxTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComputedTax
 */
export interface ComputedTax {
    /**
     * 
     * @type {TaxType}
     * @memberof ComputedTax
     */
    type?: TaxType;
    /**
     * 
     * @type {string}
     * @memberof ComputedTax
     */
    description?: string;
    /**
     * 10
     * @type {number}
     * @memberof ComputedTax
     */
    percent?: number;
    /**
     * 0.1
     * @type {number}
     * @memberof ComputedTax
     */
    rate?: number;
    /**
     * 50 * .1 = 5
     * @type {number}
     * @memberof ComputedTax
     */
    amount?: number;
}

/**
 * Check if a given object implements the ComputedTax interface.
 */
export function instanceOfComputedTax(value: object): value is ComputedTax {
    return true;
}

export function ComputedTaxFromJSON(json: any): ComputedTax {
    return ComputedTaxFromJSONTyped(json, false);
}

export function ComputedTaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputedTax {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : TaxTypeFromJSON(json['type']),
        'description': json['description'] == null ? undefined : json['description'],
        'percent': json['percent'] == null ? undefined : json['percent'],
        'rate': json['rate'] == null ? undefined : json['rate'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function ComputedTaxToJSON(value?: ComputedTax | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': TaxTypeToJSON(value['type']),
        'description': value['description'],
        'percent': value['percent'],
        'rate': value['rate'],
        'amount': value['amount'],
    };
}

